<tds-modal size="sm" closeIconButtonLabel="Close">
  <tds-modal-title>Analysts you can contact</tds-modal-title>

  <div class="contact-informations" id="fullname">
    {{  analyst()?.fullname }}
  </div>

  @if(analyst()?.email) {
    <a  href="mailto:{{ analyst()?.email }}">
      {{ analyst()?.email }}
    </a>
  }

  <div class="contact-app-list">
    <a href="sip:{{ analyst()?.email }}">
      <img src="assets/images/teams-logo.png" alt="link to teams contact" style="width: 50px" />
    </a>
  </div>

</tds-modal>
